<script setup>
// import { useI18n } from 'vue-i18n'

const props = defineProps({
  message: {
    type: String,
    default: null//() => useI18n().t('common.loading')
  }
})
</script>

<template>
  <div class="loading-container d-flex flex-column align-center justify-center">
    <v-progress-circular
      indeterminate
      color="primary"
      size="64"
    />
    <small v-if="message" class="d-block mt-4 text-uppercase text-medium-emphasis">{{ message }}</small>
  </div>
</template>


<style scoped>
.loading-container {
  min-height: 400px;
}
</style>